exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel.panel-accent-green {\n    border-top: 3px solid #5cb85c;\n}\n.panel.panel-accent-red {\n    border-top: 3px solid #d9534f;\n}\n.panel.panel-accent-blue {\n    border-top: 3px solid #5bc0de;\n}\n.panel.panel-accent-orange {\n    border-top: 3px solid #f39c12;\n}\n.panel.panel-accent-pink {\n    border-top: 3px solid #e671b8;\n}\n.panel.panel-accent-purple {\n    border-top: 3px solid #7b4f9d;\n}\n.panel.panel-accent-lime {\n    border-top: 3px solid #8cbf26;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader!./app/css/bootstrap-custom-panel.css
// module id = 235
// module chunks = 0